export interface MaintenanceState {
	maintenanceTime: string | null;
}

export const initialMaintenanceState: MaintenanceState = {
	maintenanceTime: null,
};
